import { render, staticRenderFns } from "./Imagewall.vue?vue&type=template&id=36faf0f5&scoped=true&"
import script from "./Imagewall.vue?vue&type=script&lang=js&"
export * from "./Imagewall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36faf0f5",
  null
  
)

export default component.exports